import { useEffect } from 'react'

const useWhiteBackground = () => {
  useEffect(() => {
    const htmlElement = document.documentElement.style
    const bodyElement = document.body.style
    htmlElement.backgroundColor = 'white'
    bodyElement.backgroundColor = 'white'
    return () => {
      htmlElement.backgroundColor = ''
      bodyElement.backgroundColor = ''
    }
  }, [])
}
export default useWhiteBackground
